import React, { memo, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";

import { Cancel, Check } from "@mui/icons-material";

import { useState } from "react";

import AuthContext from "../../../../Context/Auth/AuthContext";
import { replaceCaracteres, trimPropsItem } from "../../../../config/const";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const RowAgregar = (props) => {
  const { setagregar, socket } = props;
  const [item, setitem] = useState({
    porImpuesto: "",
    porCodigo: "",
    porPorcentaje: "",
    porConcepto: "",
    porUser: "",
    porFecReg: "",
    Todos: "",
  });

  const classes = useRowStyles();
  //gql eliminar user

  const { usuario } = useContext(AuthContext);
  const handleAgregar = async () => {
    try {
      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,
          tabla: "porcentajeRetencion",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          porUser: usuario.usuario,
          porEmpresa: usuario.rucempresa,
        })
      );
    } catch (error) {}
  };
  const botonDisabled = () => {
    if (
      item.porImpuesto === "" ||
      item.porCodigo === "" ||
      item.porPorcentaje === "" ||
      item.porConcepto === ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell></TableCell> {/* boton */}
        <TableCell>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            <IconButton
              className={classes.margin}
              onClick={() => {
                setagregar(false);
                setitem({
                  fecReg: 0,
                  user: "",
                  nombre: "",
                  estado: "ACTIVO",
                });
              }}
            >
              <Cancel fontSize="small" color="secondary" />
            </IconButton>

            <IconButton
              color={
                botonDisabled
                  ? botonDisabled()
                    ? "inherit"
                    : "secondary"
                  : "secondary"
              }
              disabled={botonDisabled()}
              className={classes.margin}
              onClick={() => {
                handleAgregar();

                setagregar(false);
                setitem({
                  fecReg: 0,
                  user: "",
                  nombre: "",
                  estado: "ACTIVO",
                });
              }}
            >
              <Check fontSize="small" />
            </IconButton>
          </Box>
        </TableCell>
        {/* las demas columnas */}
        <TableCell fontSize="small">
          <TextField
            id=""
            value={item.porImpuesto}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                porImpuesto: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
            select
            InputLabelProps={{ shrink: true }}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">Seleccione</MenuItem>
            {["RENTA", "IVA", "ISD"].map((itemRow) => {
              return <MenuItem value={itemRow}>{itemRow} </MenuItem>;
            })}
          </TextField>
        </TableCell>{" "}
        <TableCell fontSize="small">
          <TextField
            type="number"
            id=""
            value={item.porCodigo}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                porCodigo: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small">
          <TextField
            type="number"
            id=""
            value={item.porPorcentaje}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                porPorcentaje: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>{" "}
        <TableCell fontSize="small">
          <TextField
            id=""
            value={item.porConcepto}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                porConcepto: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(RowAgregar);
